<template>
  <div class="limit-table" style="overflow: hidden">
    <b-input class="mb-2" v-model="team.name" name="name" />
    <b-textarea class="mb-2" v-model="team.description" name="description" />
    <b-input-group prepend="Novo Membro" class="mt-2">
      <b-form-input v-model="newMemberEmail"></b-form-input>
      <b-input-group-append>
        <b-button @click="addNewMember()" variant="primary">
          Adicionar membro pelo email
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <b-button class="mt-2" @click="updateTeam()" variant="success">
      Salvar alterações
    </b-button>
    <hr />
    <div
      class="row limit-table m-auto"
      style="height: 500px; overflow-x: hidden"
    >
      <table class="table">
        <thead class="letter-orange">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Nome</th>
            <th scope="col">Posts</th>
            <th scope="col">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="member in team.members" v-bind:key="member.id">
            <th scope="row">
              {{ member.id }}
            </th>
            <td>
              {{ member.name }}
            </td>
            <td>
              {{ member.posts_count }}
            </td>
            <td>
              <div @click="removeTeamMember(member.id)" class="btn btn-danger">
                <i class="fas fa-trash-alt" aria-label="Remover Membro"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import makeToast from '../../../mixins/makeToast';

export default {
  mixins: [makeToast],
  data: () => ({
    team: {},
    newMemberEmail: 'email@exemplo.com',
  }),
  computed: {
    ...mapState(['token', 'dadosUsuario']),
    ...mapGetters('journal', ['setTeams']),
  },
  props: ['id'],
  computed: {
    ...mapState(['token', 'dadosUsuario']),
  },
  created() {
    this.getTeam();
  },
  methods: {
    ...mapActions('journal', [
      'getTeamByID',
      'updateTeamByID',
      'addMember',
      'removeMember',
    ]),
    getTeam() {
      this.getTeamByID({
        userId: this.dadosUsuario.id,
        teamId: this.id,
      })
        .then((response) => {
          console.log(response);
          this.team = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.makeToast(
            'Oopss!',
            'Não foi possivel carregar esta equipe!',
            'danger'
          );
        });
    },
    updateTeam() {
      this.updateTeamByID({
        userId: this.dadosUsuario.id,
        teamId: this.team.id,
        data: this.team,
      })
        .then((response) => {
          this.makeToast(
            'Sucesso!',
            'Equipe atualizada com sucesso!',
            'success'
          );
        })
        .catch((error) => {
          this.makeToast('Oopss!', error.response.data.message, 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    addNewMember() {
      this.addMember({
        userId: this.dadosUsuario.id,
        teamId: this.team.id,
        data: {
          new_member_email: this.newMemberEmail,
        },
      })
        .then((response) => {
          this.makeToast(
            'Sucesso!',
            'Usuário adicionado com sucesso!',
            'success'
          );
        })
        .catch((error) => {
          this.makeToast('Oopss!', error.response.data.message, 'danger');
        })
        .finally(() => {
          this.getTeam();
        });
    },
    removeTeamMember(id) {
      console.log({
        userId: this.dadosUsuario.id,
        teamId: this.team.id,
        removedMemberId: id,
      });
      this.removeMember({
        userId: this.dadosUsuario.id,
        teamId: this.team.id,
        removedMemberId: id,
      })
        .then((response) => {
          this.makeToast(
            'Sucesso!',
            'Usuário removido com sucesso!',
            'success'
          );
        })
        .catch((error) => {
          this.makeToast('Oopss!', error.response.data.message, 'danger');
        })
        .finally(() => {
          this.getTeam();
        });
    },
  },
};
</script>

<style scoped>
.border-radius {
  border-radius: 8px;
}

.no-text-decoration:hover {
  color: var(--orange-primary);
  text-decoration: none;
}

.table td,
.table th {
  vertical-align: middle;
}
</style>
